import { createRoot, hydrateRoot } from 'react-dom/client';

const hasServerRenderedPage = (container) => {
    const focusWrapper = container.querySelector('#gatsby-focus-wrapper');

    return Boolean(focusWrapper && focusWrapper.childNodes.length > 0);
};

const browserHydrateFunction = () => {
    return (element, container) => {
        if (hasServerRenderedPage(container)) {
            hydrateRoot(container, element);
            return;
        }

        const root = createRoot(container);
        root.render(element);
    };
};

export default browserHydrateFunction;
